import { UPDATE_MODEL_EVENT, baseProps } from '@vuesax-plus/constants'
import { buildProps, isBoolean, isNumber } from '@vuesax-plus/utils'

import type { ExtractPropTypes } from 'vue'
import type Alert from './alert.vue'

export const alertProps = buildProps({
  ...baseProps,
  border: {
    type: Boolean,
  },
  closable: {
    type: Boolean,
  },
  flat: {
    type: Boolean,
  },
  gradient: {
    type: Boolean,
  },
  modelValue: {
    type: Boolean,
    default: true,
  },
  hiddenContent: {
    type: Boolean,
    default: null,
  },
  page: {
    type: Number,
    default: 0,
  },
  progress: {
    type: [Number, String],
    default: 0,
  },
  shadow: {
    type: Boolean,
  },
  relief: {
    type: Boolean,
  },
  solid: {
    type: Boolean,
  },
  time: {
    type: [Number, String],
    default: 0,
  },
} as const)

export type AlertProps = ExtractPropTypes<typeof alertProps>

export const alertEmits = {
  [UPDATE_MODEL_EVENT]: (value: boolean) => isBoolean(value),
  'update:page': (value: number) => isNumber(value),
  'update:hiddenContent': (value: boolean) => isBoolean(value),
}

export type AlertEmits = typeof alertEmits

export type AlertInstance = InstanceType<typeof Alert>
